import { TextV2 } from '@withjoy/joykit';
import React, { useCallback } from 'react';
import { Car } from '@withjoy/joykit/icons';

import { useTranslation } from '@shared/core';
import { GUEST_GUIDE_UTM } from './guestGuideUtm.constants';
import { useGuestGuideTelemetry } from '../GuestGuideTelemetry';
import { useIsFeatureEnabled } from '@shared/core/featureFlags';
import { GuestGuideActionButton } from '../GuestGuideActionButton';
import { useCarbonIframeLinkProps } from '@shared/hooks/useCarbonIframeLinkProps';
import { useEventCarSearchUrl } from '@shared/utils/accommodations/useEventCarSearchUrl';

type CarRentalsActionProps = Readonly<{
  isAttending: boolean;
}>;

export const CarRentalsAction: React.FC<CarRentalsActionProps> = ({ isAttending }) => {
  const telemetry = useGuestGuideTelemetry();
  const { tq } = useTranslation('guestGuide');
  const carbonIframeLinkProps = useCarbonIframeLinkProps();
  const carSearchUrl = useEventCarSearchUrl(GUEST_GUIDE_UTM);
  const [isGuestGuideCarRentalEnabled] = useIsFeatureEnabled('guestGuideCarRentalAction');

  const handleClick = useCallback(() => {
    telemetry.clickCarRentals();
  }, [telemetry]);

  if (!isGuestGuideCarRentalEnabled || !carSearchUrl) {
    return null;
  }

  return (
    <GuestGuideActionButton
      as="a"
      href={carSearchUrl}
      onClick={handleClick}
      icon={<Car size={32} />}
      {...carbonIframeLinkProps}
    >
      <TextV2 typographyVariant="button2">{isAttending ? tq`Book a Car Rental` : tq`Explore Car Rentals`}</TextV2>
    </GuestGuideActionButton>
  );
};
